import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import InputAdornment from '@mui/material/InputAdornment';

import NumberInput from "./NumberInput.js";

import settingSystem from "../SettingSystem.js"
import SheetMusicPlayer from "../components/SheetMusicPlayer.js"

import TextManager from '../TextManager';

// import Switch from '@mui/material/Switch';



export default class SettingsPage extends React.Component {
	
	state = {
	}

	welcomePageOpened = this.props.welcomePageOpened;

	tempZoomLevel = null;

	// componentDidMount() {
		
	// }
	
	render() {
		// const osmd = this.props.osmd;

		const handleChange = (event) => {
			this.setState({noteNameMode: event.target.value})
		};
		
		const setDropdownValue = (event, stateName) => {
			//console.log(stateName);
			this.setState({[stateName]: event.target.value});
		}
		
		const onTextInputChanged = (event, stateName) => {
			this.setState({[stateName]: event.target.value});
		}

		return (
		      
			<div className="PopupPage">
				{/*<CloseIcon sx={{float:"right", left:"100px"}}/>*/}
				
				<div className="PageTitle">{TextManager.getText("settings")}</div>
				
				<List className="PageList">
				  
				  <ListItem>
					<ListItemText primary={TextManager.getText("zoom_level")} />
					<NumberInput 
						disabled={this.welcomePageOpened}
						defaultValue={Math.round(settingSystem.getSetting("zoomLevel") * 100)}
						suffix="%"
						step={10}
						min={50}
						max={300}
						width="160px"
						onCommit={
							(v)=>{
								// this.props.onZoomChanged(v * 0.01);

								// settingSystem.setSetting("zoomLevel", v * 0.01, this);
								this.tempZoomLevel = v;
							}
						}
					/>
				  </ListItem>

				  <ListItem>
					<ListItemText primary={TextManager.getText("language")} />
					<Box sx={{ minWidth: 120 }}>
						<FormControl fullWidth>
						<InputLabel id="demo-simple-select-label"></InputLabel>
							<Select
							  	labelId="demo-simple-select-label"
							  	id="demo-simple-select"
							  	value={settingSystem.getSetting("language")}
								onChange={(e)=>{settingSystem.setSetting("language", e.target.value, this);}}
							>
								<MenuItem value={"en"}>English</MenuItem>
								<MenuItem value={"zh_hk"}>繁體中文</MenuItem>
								<MenuItem value={"zh_cn"}>简体中文</MenuItem>
							</Select>
						</FormControl>
						</Box>
				  </ListItem>
				  
				  <ListItem>
					<ListItemText primary={TextManager.getText("note_name_mode")} />
					<Box sx={{ minWidth: 120 }}>
						<FormControl fullWidth>
						<InputLabel id="demo-simple-select-label"></InputLabel>
							<Select
							  	labelId="demo-simple-select-label"
							  	id="demo-simple-select"
								disabled={this.welcomePageOpened} 
							  	value={settingSystem.getSetting("noteNameMode")}
								onChange={(e)=>{settingSystem.setSetting("noteNameMode", e.target.value, this);}}
							>
								<MenuItem value={0}>{TextManager.getText("none")}</MenuItem>
								<MenuItem value={1}>{TextManager.getText("alphabets")}</MenuItem>
								<MenuItem value={2}>{TextManager.getText("sol_fixed")}</MenuItem>
								<MenuItem value={3}>{TextManager.getText("sol_movable")}</MenuItem>
							</Select>
						</FormControl>
						</Box>
				  </ListItem>
				  
				  <ListItem>
					<ListItemText primary={TextManager.getText("color_mode")} />
						<Box sx={{ minWidth: 120 }}>
							<FormControl fullWidth>
							<InputLabel id="demo-simple-select-label"></InputLabel>
								<Select
								  	labelId="demo-simple-select-label"
								  	id="demo-simple-select"
									  disabled={this.welcomePageOpened} 
									value={settingSystem.getSetting("noteColorMode")}
									onChange={(e)=>{
										settingSystem.setSetting("noteColorMode", e.target.value, this);
										SheetMusicPlayer.singleton.setKeyBoardActiveNoteByCursorHover();
									}}
								>
									<MenuItem value={0}>{TextManager.getText("none")}</MenuItem>
									<MenuItem value={1}>{TextManager.getText("colored_by_note")}</MenuItem>
									<MenuItem value={2}>{TextManager.getText("colored_by_track")}</MenuItem>
								</Select>
							</FormControl>
						</Box>
				  </ListItem>
				  
				  <ListItem>
					<ListItemText primary={TextManager.getText("display_lyrics")} />
					<Switch edge="end" disabled={this.welcomePageOpened} checked={settingSystem.getSetting("showLyrics")} onChange={(e)=>settingSystem.setSetting("showLyrics", e.target.checked, this)}/>
				  </ListItem>
				  
				  <ListItem>
					<ListItemText primary={TextManager.getText("display_piano_keyboard")} />
					<Switch edge="end" checked={settingSystem.getSetting("showKeyboard")} onChange={(e)=>settingSystem.setSetting("showKeyboard", e.target.checked, this)}/>
				  </ListItem>

				  <ListItem>
					<ListItemText primary={TextManager.getText("always_show_full_keyboard")} />
					<Switch edge="end" checked={settingSystem.getSetting("alwaysShowFullKeyboard")} onChange={(e)=>settingSystem.setSetting("alwaysShowFullKeyboard", e.target.checked, this)}/>
				  </ListItem>
				  
				</List>
				
				<Stack spacing={2} direction="row" justifyContent="center">
					<Button onClick={
						() => {
							if (this.tempZoomLevel != null) {
								SheetMusicPlayer.singleton.pause();
								settingSystem.setSetting("zoomLevel", this.tempZoomLevel * 0.01, this);
							}

							this.props.close();
						}
					} variant="contained">{TextManager.getText("confirm")}</Button>
				</Stack>
			</div>
		);
	}
}